// Ubicación en el repo: src/lib/monthGrid.js
// Geometría de la vista mensual de Agenda — replica renderMonthGrid() de
// prototipo-actual.html (líneas ~916-960): semana empieza en lunes,
// celdas en blanco antes del día 1 / después del último para completar
// filas de 7.
export const DOW_LABELS = ['LUN', 'MAR', 'MIÉ', 'JUE', 'VIE', 'SÁB', 'DOM'];

export function monthLabel(monthStr) {
  const [y, m] = monthStr.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString('es-CL', { month: 'long', year: 'numeric' });
}

export function shiftMonth(monthStr, delta) {
  let [y, m] = monthStr.split('-').map(Number);
  m += delta;
  if (m < 1) {
    m = 12;
    y--;
  }
  if (m > 12) {
    m = 1;
    y++;
  }
  return `${y}-${String(m).padStart(2, '0')}`;
}

// null = celda de relleno, número = día del mes.
export function buildMonthCells(monthStr) {
  const [y, m] = monthStr.split('-').map(Number);
  const startWeekday = (new Date(y, m - 1, 1).getDay() + 6) % 7; // 0 = lunes
  const daysInMonth = new Date(y, m, 0).getDate();
  const cells = [];
  for (let i = 0; i < startWeekday; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);
  return cells;
}

// [monthStart, monthEnd) para queries — monthEnd es el día 1 del mes
// siguiente, no el último día de este mes.
export function monthRange(monthStr) {
  const [y, m] = monthStr.split('-').map(Number);
  const start = `${monthStr}-01`;
  const nextM = m === 12 ? 1 : m + 1;
  const nextY = m === 12 ? y + 1 : y;
  const end = `${nextY}-${String(nextM).padStart(2, '0')}-01`;
  return { start, end };
}
